import { ethers } from 'ethers';
import { getContractAddress } from 'utilities';
import config from 'config';
import dlVaultAbi from 'constants/contracts/abis/dlVault.json';

import { BscChainId } from 'types';

export interface SetInviterInput {
  userSigner: ethers.Signer;
  inviterAddress: string;
  chainId?: BscChainId;
}

export interface SetInviterOutput {
  success: boolean;
  txHash?: string;
  error?: string;
}

const setInviter = async ({
  userSigner,
  inviterAddress,
  chainId = config.chainId,
}: SetInviterInput): Promise<SetInviterOutput> => {
  try {
    const userAddress = await userSigner.getAddress();
    const dlVault = new ethers.Contract(
      getContractAddress('dlVault'),
      dlVaultAbi,
      userSigner,
    );

    const tx = await dlVault.setInviter(inviterAddress, { from: userAddress });
    await tx.wait();

    return {
      success: true,
      txHash: tx.hash,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};

export default setInviter;
